import React, { useState } from 'react';
import axios from 'axios';

const ClearanceValidator = () => {
  const [atcFile, setAtcFile] = useState(null);
  const [pilotFile, setPilotFile] = useState(null);
  const [result, setResult] = useState(null);

  const handleSubmit = async () => {
    if (!atcFile || !pilotFile) return alert("Both files are required");

    const formData = new FormData();
    formData.append("atc", atcFile);
    formData.append("pilot", pilotFile);

    try {
      const res = await axios.post("https://ficon-x.com/api/transcribe_and_compare", formData);
      setResult(res.data);
    } catch (err) {
      console.error("Error submitting audio:", err);
    }
  };

  return (
    <div style={{ padding: 20, background: "white", borderRadius: 10 }}>
      <h3>🎧 Clearance Validator</h3>

      <div>
        <label>ATC Audio</label>
        <input type="file" accept="audio/*" onChange={(e) => setAtcFile(e.target.files[0])} />
      </div>

      <div>
        <label>Pilot Readback</label>
        <input type="file" accept="audio/*" onChange={(e) => setPilotFile(e.target.files[0])} />
      </div>

      <button onClick={handleSubmit} style={{ marginTop: 10 }}>Compare</button>

      {result && (
        <div style={{ marginTop: 20 }}>
          <p><strong>ATC:</strong> {result.atc}</p>
          <p><strong>Pilot:</strong> {result.pilot}</p>
          <p style={{ color: result.mismatches.includes('heading') ? 'red' : 'green' }}>
            Heading: {result.heading.atc} vs {result.heading.pilot}
          </p>
          <p style={{ color: result.mismatches.includes('altitude') ? 'red' : 'green' }}>
            Altitude: {result.altitude.atc} vs {result.altitude.pilot}
          </p>
          <p><strong>Status:</strong> {result.match ? "✅ Matched" : "❌ Mismatch"}</p>
        </div>
      )}
    </div>
  );
};

export default ClearanceValidator;
